import {STOPPAGE_ANALYSIS_SUB_PATH} from '@features/stoppage-analysis'
import {PLANT_DOWNTIME} from '@hconnect/common/consts'
import {PLANT_KPI as PlantKpi} from '@hconnect/common/hproduce/config'
import {STATUS} from '@hconnect/common/hproduce/config/hproduce'

// Base routes
export const HPRODUCE_HROC = '/hroc'
export const PERFORMANCE = '/performance'
export const DOWNTIME = '/downtime'
export const TASKS = '/tasks'
export const CHECKLISTS = `${HPRODUCE_HROC}/checklists`
export const EXPERT_SYSTEM_USAGE_RATE = '/expert-system-usage-rate'
export const AREA_EXPERT_SYSTEM_USAGE_RATE = `${EXPERT_SYSTEM_USAGE_RATE}/area/:areaId`
export const REGION_EXPERT_SYSTEM_USAGE_RATE = `${AREA_EXPERT_SYSTEM_USAGE_RATE}/region/:regionId`
export const COUNTRY_EXPERT_SYSTEM_USAGE_RATE = `${REGION_EXPERT_SYSTEM_USAGE_RATE}/country/:countryId`
export const PLANT_EXPERT_SYSTEM_USAGE_RATE = `${COUNTRY_EXPERT_SYSTEM_USAGE_RATE}/plant/:plantId`

export const TERMS_AND_CONDITIONS = '/tc'
export const PRIVACY_POLICY = '/privacy'

// Extended shared routes
export const PLANT_KPI_STATUS = `${STATUS}/plant/:plantId`
export const LOCATION_KPI_STATUS = `${STATUS}/location/:locationId`

export const PLANT_KPI = PlantKpi
export const LOCATION_KPI = `${PERFORMANCE}/location/:locationId`

export const PLANT_DOWNTIME_STATS = `${PLANT_DOWNTIME}/downtime-statistics`
export const PLANT_DOWNTIME_STOPPAGES = `${PLANT_DOWNTIME}/stoppages`
export const PLANT_DOWNTIME_STOPPAGES_DETAILS = `${PLANT_DOWNTIME_STOPPAGES}/:groupType/:groupId`
export const PLANT_DOWNTIME_STOPPAGES_DETAILS_FOR_CODE = `${PLANT_DOWNTIME_STOPPAGES_DETAILS}/stoppageCode/:stoppageCode`

// HROC shared routes
export const RELIABILITY_ENGINEER_DASHBOARD = `${HPRODUCE_HROC}/reliability-engineer-dashboard`
export const PLANT_RELIABILITY_ENGINEER_DASHBOARD = `${RELIABILITY_ENGINEER_DASHBOARD}/plant/:plantId`
export const RELIABILITY_ENGINEER_STOPPAGE_ANALYSIS = `${PLANT_RELIABILITY_ENGINEER_DASHBOARD}/${STOPPAGE_ANALYSIS_SUB_PATH}`
export const RELIABILITY_ENGINEER_PLANT_KPI = `${PLANT_RELIABILITY_ENGINEER_DASHBOARD}/PerformanceReports`
export const RELIABILITY_ENGINEER_PLANT_KPI_STOPPAGE_ANALYSIS = `${RELIABILITY_ENGINEER_PLANT_KPI}/${STOPPAGE_ANALYSIS_SUB_PATH}`

export const PROCESS_ENGINEER_DASHBOARD = `${HPRODUCE_HROC}/process-engineer-dashboard`
export const PLANT_PROCESS_ENGINEER_DASHBOARD = `${PROCESS_ENGINEER_DASHBOARD}/plant/:plantId`
export const PROCESS_ENGINEER_STOPPAGE_ANALYSIS = `${PLANT_PROCESS_ENGINEER_DASHBOARD}/${STOPPAGE_ANALYSIS_SUB_PATH}`
export const PROCESS_ENGINEER_PLANT_KPI = `${PLANT_PROCESS_ENGINEER_DASHBOARD}/PerformanceReports`
export const PROCESS_ENGINEER_PLANT_KPI_STOPPAGE_ANALYSIS = `${PROCESS_ENGINEER_PLANT_KPI}/${STOPPAGE_ANALYSIS_SUB_PATH}`

export const OPTIMIZATION_SPECIALIST_DASHBOARD = `${HPRODUCE_HROC}/optimization-specialist-dashboard`
export const PLANT_OPTIMIZATION_SPECIALIST_DASHBOARD = `${OPTIMIZATION_SPECIALIST_DASHBOARD}/plant/:plantId`
export const OPTIMIZATION_SPECIALIST_STOPPAGE_ANALYSIS = `${PLANT_OPTIMIZATION_SPECIALIST_DASHBOARD}/${STOPPAGE_ANALYSIS_SUB_PATH}`
export const OPTIMIZATION_SPECIALIST_PLANT_KPI = `${PLANT_OPTIMIZATION_SPECIALIST_DASHBOARD}/PerformanceReports`
export const OPTIMIZATION_SPECIALIST_PLANT_KPI_STOPPAGE_ANALYSIS = `${OPTIMIZATION_SPECIALIST_PLANT_KPI}/${STOPPAGE_ANALYSIS_SUB_PATH}`

export const MAJOR_OUTAGE_LEAD_DASHBOARD = `${HPRODUCE_HROC}/major-outage-lead-dashboard`
export const PLANT_MAJOR_OUTAGE_LEAD_DASHBOARD = `${MAJOR_OUTAGE_LEAD_DASHBOARD}/plant/:plantId`
export const MAJOR_OUTAGE_LEAD_STOPPAGE_ANALYSIS = `${PLANT_MAJOR_OUTAGE_LEAD_DASHBOARD}/${STOPPAGE_ANALYSIS_SUB_PATH}`
export const MAJOR_OUTAGE_LEAD_DOWNTIME = `${PLANT_DOWNTIME}/major-outage-lead`
export const MAJOR_OUTAGE_LEAD_DOWNTIME_STOPPAGES = `${MAJOR_OUTAGE_LEAD_DOWNTIME}/stoppages`
export const MAJOR_OUTAGE_LEAD_DOWNTIME_STOPPAGES_DETAILS = `${MAJOR_OUTAGE_LEAD_DOWNTIME}/stoppages/:groupType/:groupId`
export const MAJOR_OUTAGE_LEAD_DOWNTIME_STOPPAGES_DETAILS_FOR_CODE = `${MAJOR_OUTAGE_LEAD_DOWNTIME}/stoppages/:groupType/:groupId/stoppageCode/:stoppageCode`
export const MAJOR_OUTAGE_LEAD_DOWNTIME_KILN_STATS = `${MAJOR_OUTAGE_LEAD_DOWNTIME}/downtime-statistics`

export const TASKS_ROUTE = '/tasks'
